package link.erpango.quip.domain.catalog

import link.erpango.quip.domain.entities.DSparePartCatalog
import link.erpango.quip.domain.entities.DSparePartType

/**
 * Spare-part categories and types used by every form (there is no backend endpoint yet).
 *
 * The backend keeps a copy of these ids to validate LLM output
 * (`quip_app/llm/validation.py`, KNOWN_SPARE_PART_TYPES); `SparePartCatalogContractTest`
 * fails if this catalog changes without updating that list too.
 */
val DefaultSparePartCatalog: DSparePartCatalog = DSparePartCatalog(
    categories = mapOf(
        "oil" to "spare_part.category.oil",
        "filters" to "spare_part.category.filters",
        "brakes" to "spare_part.category.brakes",
        "tires" to "spare_part.category.tires",
        "battery" to "spare_part.category.battery",
        "lights" to "spare_part.category.lights",
        "other" to "spare_part.category.other"
    ),
    sparePartTypes = listOf(
        sparePartType("engine_oil", "oil", hasQuantity = true, unit = "L"),
        sparePartType("transmission_oil", "oil", hasQuantity = true, unit = "L"),
        sparePartType("oil_filter", "filters"),
        sparePartType("air_filter", "filters"),
        sparePartType("fuel_filter", "filters"),
        sparePartType("cabin_filter", "filters"),
        sparePartType("brake_pads_front", "brakes"),
        sparePartType("brake_pads_rear", "brakes"),
        sparePartType("brake_discs", "brakes"),
        sparePartType("tire", "tires"),
        sparePartType("battery_12v", "battery"),
        sparePartType("brake_fluid", "brakes", hasQuantity = true, unit = "L"),
        sparePartType("all_brake_pads", "brakes"),
        sparePartType("other", "other")
    ).associateBy { it.id }
)

private fun sparePartType(
    id: String,
    categoryId: String,
    hasQuantity: Boolean = false,
    unit: String? = null
) = DSparePartType(
    id = id,
    categoryId = categoryId,
    translationKey = "spare_part.type.$id",
    hasQuantity = hasQuantity,
    unit = unit
)
